import { render, staticRenderFns } from "./LeftNavigation.vue?vue&type=template&id=bd2e8410&"
import script from "./LeftNavigation.vue?vue&type=script&lang=js&"
export * from "./LeftNavigation.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavigation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports